import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ManeuverOutcomeDraft } from "src/app/models/models";
import { ManeuverSidebarStatus, resolveManeuverSidebarStatus } from "../../utils/ts1-rating-outcome-interaction";

@Component({
	selector: "app-ts1-rating-maneuver-sidebar",
	templateUrl: "./ts1-rating-maneuver-sidebar.component.html",
	styleUrls: ["./ts1-rating-maneuver-sidebar.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1RatingManeuverSidebarComponent {
	@Input() maneuvers: string[] = [];
	@Input() maneuverCodes: string[] = [];
	@Input() maneuverOutcomes: ManeuverOutcomeDraft[] = [];
	@Input() hasSecondCandidate = false;
	@Input() activeIndex = 0;
	@Output() activeIndexChange = new EventEmitter<number>();

	select(index: number): void {
		this.activeIndexChange.emit(index);
	}

	statusForIndex(index: number): ManeuverSidebarStatus {
		const code = this.maneuverCodes[index];
		if (!code) return "none";
		const outcome = this.maneuverOutcomes.find((o) => o.maneuverCode === code);
		return resolveManeuverSidebarStatus(outcome, this.hasSecondCandidate);
	}
}
